import React from "react"
import { graphql } from "gatsby"
import { HtmlTag } from "../libs/helpers"
import LinkList from "./LinkList"

import * as styles from "./linklisttitle.module.scss"

const LinkListTitle = ({ title, linkListItems }) => {
  return (
    <section className={styles['wrap']}>
      <div>
        { title &&
        <div className={styles['title']}>
          <HtmlTag tagName={title.header}>
            {title.copy}
          </HtmlTag>
        </div>
        }
        {linkListItems &&
        <LinkList theme='llTitle' linkListItems={linkListItems} />
        }
      </div>
    </section>
  )
}

export default LinkListTitle

export const query = graphql`
fragment LinkListTitleData on STRAPI__COMPONENT_SUPERCUSTOM_LINK_LIST_TITLE {
  title {
    copy
    header
  }
  linkListItems {
    label
    href
    page {
      path
      title
    }
    text
    image {
      alternativeText
      localFile {
        childImageSharp {
          gatsbyImageData(height: 100 placeholder: BLURRED)
        }
      }
    }
  }
}
`
